import React from 'react';
import { Route, Routes } from 'react-router-dom';

import {
  GreetingPage,
  GreetingsPage,
  ErrorPage,
  BadgeHomePage,
  BadgeLoginPage,
  BadgeQueueInfoPage,
} from '../components/pages';

export const Routing: React.FC = () => {
  return (
    <Routes>
      <Route path="/greeting/:documentId" element={<GreetingPage />} />
      <Route path="badge" >
        <Route path="home" element={<BadgeHomePage />} />
        <Route path="login" element={<BadgeLoginPage />} />
        <Route path="queue-info" element={<BadgeQueueInfoPage />} />
      </Route>
      <Route path="/404" element={<ErrorPage />} />
    </Routes>
  );
};
